import "core-js/modules/es.symbol";
import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.function.name";
import "core-js/modules/es.object.assign";
import "core-js/modules/es.object.get-own-property-descriptor";
import "core-js/modules/es.object.keys";
import "core-js/modules/es.string.replace";
import "core-js/modules/web.dom-collections.for-each";

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import Isvg from 'react-inlinesvg';
import { defineMessages, injectIntl } from 'react-intl';
import { pick, omit } from 'helpers/object';
import { DESIGN_SYSTEM } from 'constants/icons';
import { KeywordSearchBoxPanel } from './KeywordSearchBoxPanel';
import { SearchBoxField } from './SearchBoxField';

var itemToString = function itemToString(i) {
  return (i ? i.name : '').replace(/<[^>]*>/g, '');
};

var messages = defineMessages({
  placeholder: {
    id: 'search.searchbox.keywordField.placeholder',
    defaultMessage: 'Find a studio or activity'
  }
});
export var KeywordFieldUnwrapped = function KeywordFieldUnwrapped(props) {
  return React.createElement(SearchBoxField, _extends({}, pick(Object.keys(SearchBoxField.propTypes), props), {
    isClearable: true,
    itemToString: itemToString,
    icon: React.createElement(Isvg, {
      src: DESIGN_SYSTEM.lookingGlass
    }),
    placeholder: props.intl.formatMessage(messages.placeholder)
  }), function (_ref) {
    var getItemProps = _ref.getItemProps,
        highlightedIndex = _ref.highlightedIndex,
        onPanelScroll = _ref.onPanelScroll;
    return React.createElement(KeywordSearchBoxPanel, _extends({}, pick(Object.keys(KeywordSearchBoxPanel.propTypes), props), {
      getItemProps: getItemProps,
      highlightedIndex: highlightedIndex,
      favoritesEnabled: false,
      onPanelScroll: onPanelScroll
    }));
  });
};
KeywordFieldUnwrapped.propTypes = _objectSpread({}, omit(['getItemProps'], KeywordSearchBoxPanel.propTypes), omit(['prompt', 'itemToString', 'children'], SearchBoxField.propTypes));
export var KeywordField = injectIntl(KeywordFieldUnwrapped);